import { FC } from 'react';
import Icon from '../icon';
import { Stack } from '@mui/material';

interface Props {
  onClick: () => void;
  disabled?: boolean;
}

const OpenDrawerButton: FC<Props> = ({ onClick, disabled }) => {
  return (
    <Stack width="100%" justifyContent="flex-end" direction="row">
      <Icon name="chevron-right" onClick={onClick} disabled={disabled} />
    </Stack>
  );
};

export default OpenDrawerButton;
